import { RoleAssignmentTarget } from '@modules/auth/components/types/user';

export function isMaintenanceInProgress(service: RoleAssignmentTarget): boolean {
  // REACT_APP_IS_MAINTENANCE: comma-separated list of services in maintenance.
  // Uses the same references to services as RoleAssignments (byc, idn) etc.
  const maintenanceEnvStr = process.env.REACT_APP_UNDER_MAINTENANCE?.toLocaleLowerCase() || '';
  const maintenanceList = maintenanceEnvStr.split(',');
  return maintenanceList.includes(service);
}
